/* This file is generated by scripts/generate-blog.js. Do not edit. */

export type BlogPost = {
	slug: string;
	title: string;
	subtitle?: string;
	date: string;
	excerpt: string;
	tags: string[];
	cover?: string;
	lang: string;
	draft: boolean;
	readingMinutes: number;
	content: string;
};

export const posts: BlogPost[] = [];
